import { createRoute } from '@tanstack/react-router';
import WaitlistPage from '@/features/dashboard/waitlist/pages/WaitlistPage.tsx';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';

export const waitlistRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/waitlist',
  component: WaitlistPage,
  validateSearch: listSearchSchema,
});
